import { render, staticRenderFns } from "./RedAsterisk.vue?vue&type=template&id=17d557d9&scoped=true&"
import script from "./RedAsterisk.vue?vue&type=script&lang=js&"
export * from "./RedAsterisk.vue?vue&type=script&lang=js&"
import style0 from "./RedAsterisk.vue?vue&type=style&index=0&id=17d557d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d557d9",
  null
  
)

export default component.exports